module.exports = __webpack_public_path__ + "icons/original/small/small-c1.857515213e12574db6ea3b7694015dd8.png";


//////////////////
// WEBPACK FOOTER
// ./src/web/icons/original/small/small-c1.png
// module id = kbZK
// module chunks = app